module.exports = __webpack_public_path__ + "static/media/Sofas & Couches.5eebc137.webp";